import { render, staticRenderFns } from "./TextoMenuActivo.vue?vue&type=template&id=0e76f41a&scoped=true&"
import script from "./TextoMenuActivo.vue?vue&type=script&lang=js&"
export * from "./TextoMenuActivo.vue?vue&type=script&lang=js&"
import style0 from "./TextoMenuActivo.vue?vue&type=style&index=0&id=0e76f41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e76f41a",
  null
  
)

export default component.exports